<script setup lang="ts">
import { toRefs } from '@vueuse/core'
import type { MenuItem } from '~/types'

interface Props {
  menuItem: MenuItem.Model
}

const props = defineProps<Props>()
const { menuItem } = toRefs(props)
const { handleClick, name, target, value } = useMenuItem(menuItem)
</script>

<template>
  <NuxtLink
    v-if="value"
    :href="value"
    :target="target"
    class="static-url-menu-item"
    @click="handleClick"
  >
    {{ name }}
    <UIExternalLinkWarning v-if="target === '_blank'" />
  </NuxtLink>
</template>
